"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _default = function _default(theme) {
  return {
    notchedOutline: {
      background: theme.palette.common.white,
      borderWidth: '0px',
      transition: 'box-shadow 0.3s ease-in-out',
      '&.rounded': {
        borderRadius: '21px'
      },
      '&.squared': {
        borderRadius: '2px'
      },
      '&.outline': {
        borderWidth: '1px'
      }
    },
    outlinedInputRoot: {
      '&.label': {
        marginTop: '24px'
      },
      '& > fieldset:first-of-type:not(.disabled)': {
        borderColor: theme.palette.secondary.navIcon
      },
      '&:hover fieldset:first-of-type:not(.disabled)': {
        borderColor: theme.palette.secondary.navIcon,
        boxShadow: '0 0 1px 0 rgba(0,0,0,0.12), 0 1px 1px 0 rgba(0,0,0,0.24), 0 0 4px 0 rgba(0,0,0,0.12), 0 4px 4px 0 rgba(0,0,0,0.24)'
      }
    },
    input: {
      zIndex: 1,
      '&.rounded': {
        paddingTop: '11px',
        paddingBottom: '11px',
        paddingLeft: '13px',
        // 20px icon + 13px spacing on each side
        paddingRight: '46px'
      },
      '&.squared': {
        paddingTop: '12px',
        paddingBottom: '12px',
        paddingLeft: '11px',
        // 20px icon + 11px spacing on each side
        paddingRight: '42px'
      }
    },
    icon: {
      fill: theme.palette.primary.main,
      width: '24px',
      height: '24px',
      '&.disabled': {
        fill: theme.palette.secondary.disabledDropdown
      },
      '&.rounded': {
        marginRight: '13px'
      },
      '&.squared': {
        marginRight: '11px'
      },
      '&.location': {
        height: '20px',
        width: '20px'
      }
    },
    select: {
      '&:focus': {
        backgroundColor: 'inherit'
      }
    },
    list: {
      '&.rounded': {
        fontSize: '13px'
      },
      '&.squared': {
        fontSize: '14px'
      },
      '& > li': {
        fontSize: 'inherit'
      }
    },
    inputLabel: {
      // See 4/3 comment below.
      width: 'calc(100% * 4/3)',
      color: theme.palette.primary.main
    },
    inputLabelTypography: {
      /**
       * The fontSize attribute must be 4/3 the fontSize of caption.
       * Why? Somewhere the fontSize of label is getting made 0.75*fontSize.
       * This is a workaround (so therefore not ideal).
       */
      fontSize: "".concat(theme.typography.caption.fontSize / 0.75, "px")
    },
    menuItem: {
      display: 'flex',
      alignItems: 'center',
      '& > svg': {
        marginRight: '4px'
      }
    }
  };
};

exports.default = _default;